export const contentLanguage = language => /^fr(?:-|$)/i.test(language || '') ? 'fr' : 'en';

export function bindDocumentLanguage(i18n, root = document.documentElement) {
    const update = () => { root.lang = contentLanguage(i18n.resolvedLanguage || i18n.language); };
    i18n.on('initialized', update);
    i18n.on('languageChanged', update);
    update();
    return () => {
        i18n.off('initialized', update);
        i18n.off('languageChanged', update);
    };
}
